var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtMedicalSupplies = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 341,
    viewBox: "0 0 450 341",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.443 66.94c-16.09-16.474-43.883-40.293-84.168-53.836-18.718-6.29-32.415-7.77-58.575-10.42-37.453-3.794-90.14-5.17-152.983 6.947-53.683 10.352-70.589 22.03-76.775 26.628-23.856 17.726-36.66 40.37-42.086 51.518-4.453 9.15-12.273 25.641-13.65 48.624-1.36 22.736 4.308 39.794 8.529 52.098 9.056 26.392 22.165 43.458 35.258 60.203 10.361 13.25 27.233 34.494 55.733 54.412 14.502 10.138 37.506 25.897 71.089 33.575 42.315 9.677 76.764.889 100.661-5.208 34.366-8.765 58.153-22.16 75.07-31.836 30.664-17.547 54.843-31.383 74.501-60.78 16.097-24.073 21.215-46.702 23.886-59.044 3.51-16.223 12.029-55.601-6.255-94.934a116.682 116.682 0 0 0-8.51-15.22",
    fill: "#CDDEE3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.305 34.003 75.393 39.51a4.083 4.083 0 0 1 1.722 5.512l-.002.003-21.51 40.954a4.083 4.083 0 0 1-5.51 1.719l-75.396-39.507a4.083 4.083 0 0 1-1.72-5.512v-.003l21.51-40.954a4.083 4.083 0 0 1 5.511-1.719z",
    fill: "#8E94B1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 252.895,
    cy: 52.578,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 271.225,
    cy: 62.182,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 288.153,
    cy: 71.055,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 306.479,
    cy: 80.663,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 241.717,
    cy: 73.865,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 260.047,
    cy: 83.469,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 276.976,
    cy: 92.345,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFC",
    fillRule: "nonzero",
    cx: 295.301,
    cy: 101.949,
    rx: 8.258,
    ry: 8.251
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#221F20",
    strokeWidth: 0.763,
    fill: "#FFFFFC",
    fillRule: "nonzero",
    d: "m240.595 59.509 68.689 36.001"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D6D7D8",
    strokeWidth: 2.29,
    fill: "#FFFFFC",
    fillRule: "nonzero",
    strokeLinecap: "round",
    d: "m246.682 53.459 11.945-1.827M265.626 59.605l10.682 5.643M290.978 66.098l-5.702 10.645M305.624 74.822l2.08 11.892M244.641 68.713l-5.702 10.642M258.864 77.822l2.08 11.892M289.558 103.101l11.945-1.83M271.507 89.241l10.682 5.643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.126 94.006 109.14-25.671c5.549-1.305 11.105 2.133 12.412 7.68l35.143 149.074c1.308 5.549-2.13 11.107-7.68 12.415l-.004.001-109.141 25.667c-5.548 1.306-11.104-2.133-12.412-7.68L84.441 106.419c-1.308-5.55 2.13-11.108 7.68-12.416l.004-.001z",
    fill: "#292D64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.315 102.283 100.738-23.696a6.339 6.339 0 0 1 7.62 4.716l32.164 136.444a6.339 6.339 0 0 1-4.716 7.624h-.002L133.38 251.065a6.339 6.339 0 0 1-7.621-4.716L93.596 109.905a6.339 6.339 0 0 1 4.718-7.624z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.612 83.138 61.203-14.397a4.4 4.4 0 0 1 5.29 3.274l2.179 9.23a4.4 4.4 0 0 1-3.275 5.292l-61.203 14.394a4.4 4.4 0 0 1-5.29-3.274l-2.18-9.229a4.4 4.4 0 0 1 3.275-5.292z",
    fill: "#5F6061",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.23 74.425c1.179 5.265-1.695 10.481-6.42 11.652-4.724 1.17-9.513-2.15-10.696-7.416-1.18-5.265 1.694-10.481 6.419-11.652 4.724-1.17 9.514 2.15 10.697 7.416z",
    fill: "#5F6061",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.452 74.04c.542 2.413-.886 4.83-3.183 5.403-2.298.571-4.603-.927-5.144-3.344-.542-2.414.885-4.831 3.182-5.403 2.298-.572 4.603.927 5.145 3.344z",
    stroke: "#CDDEE3",
    strokeWidth: 0.382,
    fill: "#CDDEE3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#DA6463",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.159 123.67c-1.847-4.418-5.599-11.754-12.918-18.388-4.263-3.866-16.712-13.818-34.553-13.227-4.35.145-17.951.591-28.42 10.97-8.876 8.8-10.368 19.654-11.303 26.456-1.939 14.096 1.954 25.15 4.198 31.295 2.042 5.594 5.667 13.627 19.375 30.651 11.636 14.45 62.514 64.714 62.598 64.802l1.282 1.193-.263-133.748.004-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67 123.67c1.847-4.418 5.599-11.754 12.918-18.388 4.263-3.866 16.712-13.818 34.553-13.227 4.35.145 17.951.591 28.42 10.97 8.876 8.8 10.368 19.654 11.303 26.456 1.939 14.096-1.954 25.15-4.198 31.295-2.042 5.594-5.667 13.627-19.375 30.651-11.636 14.45-62.514 64.714-62.598 64.802l-1.282 1.193.263-133.748-.004-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.918 239.212a807.695 807.695 0 0 1 2.023-69.38M303.476 123.995c.164.179.309.377.427.59M305.468 123.64l-.577 1.327M302.926 123.228c.134.084.233.21.332.336.45.576.9 1.151 1.355 1.723.1.126.198.252.282.39M303.59 133.916c.012 14.751.008 29.503-.011 44.25 0 .199-.02.427-.183.538-.164.11-.447-.126-.302-.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59 134.693c-1.275 14.058 1.301 28.146 2.08 42.242.015.26.023.537-.115.759-.114.179-.305.29-.48.408-1.355.93-1.802 2.691-2.149 4.297 1.923-7.893-.114-16.163.088-24.28-.02 9.109-.035 18.217-.054 27.326"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.586 239.918c.092 3.755.061 7.515-.087 11.27-.05 1.228 1.858 1.224 1.908 0 .149-3.755.175-7.51.088-11.27-.031-1.224-1.94-1.228-1.909 0z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.776 118.859V96.162c2.095-10.97 10.67-19.282 20.825-20.57 13.838-1.758 24.76 10.26 26.981 20.097.374 1.654.47 3.119.474 4.255v66.914",
    stroke: "#462D41",
    strokeWidth: 4.961
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47273E",
    fillRule: "nonzero",
    d: "M348.405 155.549h6.881v3.088h-6.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.903 148.118a5.5 5.5 0 0 1 5.5 5.494v9.555h-11v-9.555a5.5 5.5 0 0 1 5.5-5.494z",
    fill: "#4299B7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4299B7",
    fillRule: "nonzero",
    x: 342.108,
    y: 149.952,
    width: 6.667,
    height: 13.779,
    rx: 3.332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.568 117.929c2.355 2.058 3.736 4.949 5.64 7.385.317.408 1.016.332 1.351 0 .401-.4.317-.942 0-1.35-1.908-2.444-3.27-5.315-5.64-7.385-.39-.34-.97-.381-1.351 0-.347.347-.39 1.006 0 1.35z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.655 124.921c.065-.633.427-1.212.744-1.75.317-.537.653-1.113.985-1.666a91.24 91.24 0 0 1 2.049-3.294c1.404-2.14 2.946-4.19 4.786-5.971a20.69 20.69 0 0 1 3.327-2.63c1.034-.653.08-2.304-.961-1.648-4.729 2.982-7.912 7.675-10.728 12.384-.855 1.426-1.935 2.882-2.106 4.579-.054.515.477.953.954.953.56 0 .9-.438.954-.953l-.004-.004z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.715 108.431c-4.622 4.3-8.129 9.707-10.224 15.655-.172.484.194 1.045.668 1.175.526.144 1.003-.18 1.175-.668 1.988-5.639 5.358-10.736 9.735-14.812.901-.84-.45-2.185-1.35-1.35h-.004z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.982 118.626c-.099.366-.099.45.008.256a6.41 6.41 0 0 1 .145-.195c.088-.118.18-.232.267-.35a121.38 121.38 0 0 1 2.05-2.562c.927-1.125 1.881-2.231 2.854-3.318l-1.595-.42c.225.95.103 1.934-.084 2.883-.103.519-.225 1.034-.332 1.548-.053.26-.107.515-.153.774-.045.26-.084.61-.133.744l.244-.42-.057.058.42-.244c-.5.133-1.138.156-1.68.22l-1.828.23.676 1.627a14.417 14.417 0 0 1 2.35-2.299c.413-.32.84-.613 1.107-1.079.138-.24.214-.491.256-.762-.034.217.084-.538.042-.305.02-.095.092-.267-.027-.118l-1.5-.195a.26.26 0 0 1-.026-.217 1.543 1.543 0 0 1-.061.217c-.038.134-.084.267-.126.4l-.298.93-.595 1.861c-.157.492.183 1.041.668 1.175.515.14 1.015-.176 1.175-.667l.721-2.261c.24-.755.653-1.628.191-2.399-.286-.472-1.107-.69-1.5-.194-.21.267-.374.518-.446.862-.03.148-.046.305-.065.453-.03.206 0-.034-.027.153-.038.11-.038.13-.004.06-.064.096-.072.119-.026.066a2.46 2.46 0 0 1-.225.22c-.13.115-.374.294-.58.454a14.568 14.568 0 0 0-2.351 2.3c-.245.305-.367.66-.199 1.04.138.313.5.633.87.588l3.027-.378c.587-.072 1.278-.057 1.618-.637.233-.4.225-.976.313-1.422.381-1.914.942-3.816.484-5.768-.16-.68-1.122-.95-1.595-.42a110.344 110.344 0 0 0-3.202 3.74 100.2 100.2 0 0 0-1.492 1.873c-.526.674-1.404 1.471-1.122 2.413.149.492.668.805 1.176.667a.957.957 0 0 0 .667-1.174v-.008zM303.06 126.713c.366 4.705.465 9.43.29 14.146-.088 2.325-.248 4.647-.313 6.973-.065 2.326-.046 4.69-.008 7.035.153 9.42.317 18.846.52 28.267.114 5.254.339 10.508 1.075 15.717.073.51.722.789 1.176.667.55-.153.74-.66.668-1.175-.645-4.54-.855-9.131-.973-13.714-.119-4.583-.184-9.387-.268-14.08-.084-4.694-.171-9.376-.255-14.062-.042-2.345-.084-4.69-.054-7.035.03-2.344.164-4.659.275-6.988.252-5.25.187-10.508-.221-15.747-.038-.515-.409-.953-.954-.953-.485 0-.993.438-.954.953l-.004-.004z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.327 194.607v9.052c0 .331.069.876-.015 1.109l.244-.42-.084.07.675-.28-.057-.007.676.279-.039-.05.245.42-.016-.062v.508l.016-.046-.92.701.05-.007c.511-.065.954-.393.954-.953 0-.466-.44-1.019-.954-.954l-.05.008c-.439.057-.779.26-.92.701-.171.534.157 1.179.702 1.327.676.187 1.26-.316 1.37-.96.092-.534.027-1.121.027-1.663v-8.769c0-1.228-1.908-1.228-1.908 0l.004-.004zM303.174 220.618c.016 6.798.035 13.6.05 20.398 0 1.228 1.912 1.228 1.908 0-.015-6.798-.034-13.6-.05-20.398 0-1.228-1.912-1.228-1.908 0z",
    fill: "#DA6463",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.908,
    strokeLinecap: "round",
    d: "M248.35 166.717h32.625l6.14-21.29 7.465 45.829 3.973-26.465h14.929l1.923 13.833 9.274-33.316 9.388 23.212h22.577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.557 165.05a80.193 80.193 0 0 0-7.423 15.781c-1.027 2.99-3.13 9.693-3.996 18.633-.599 6.18-1.408 14.512 1.332 24.719 1.199 4.453 3.633 11.365 8.942 18.812h15.883c2.034-2.864 4.576-7 6.633-12.361.557-1.453 2.278-6.12 3.266-13.051.405-2.84 1.893-14.5-1.675-29.366a85.273 85.273 0 0 0-8.606-21.885l-14.353-1.282h-.003z",
    fill: "#4A273D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#39748F",
    fillRule: "nonzero",
    x: 347.325,
    y: 162.687,
    width: 24.218,
    height: 6.39,
    rx: 3.195
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#39748F",
    fillRule: "nonzero",
    x: 347.168,
    y: 241.935,
    width: 24.218,
    height: 6.39,
    rx: 3.195
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.174 118.953 59.066-13.71a8.863 8.863 0 0 1 10.637 6.625 8.856 8.856 0 0 1-6.623 10.632l-59.067 13.711a8.863 8.863 0 0 1-10.636-6.626 8.856 8.856 0 0 1 6.623-10.632z",
    fill: "#E3E4E5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DC4D55",
    fillRule: "nonzero",
    cx: 126.745,
    cy: 130.77,
    rx: 16.654,
    ry: 16.639
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m120.577 121.203 6.992-1.658 4.874 20.522-6.992 1.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m136.12 124.71 1.722 6.97-20.497 5.053-1.721-6.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    fillRule: "nonzero",
    d: "m117.238 162.66 92.573-21.71 1.21 5.153-92.573 21.71zM119.607 172.757l92.573-21.71 1.21 5.152-92.573 21.71zM121.984 182.877l92.574-21.71 1.21 5.152-92.573 21.71zM124.533 193.718l92.574-21.71 1.21 5.152-92.573 21.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E4E5",
    fillRule: "nonzero",
    d: "m130.448 219.665 92.574-21.71 4.138 17.613-92.574 21.71z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#462D41",
    fillRule: "nonzero",
    x: 215.255,
    y: 150.143,
    width: 18.371,
    height: 16.139,
    rx: 4.37
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.494 115.713)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#462D41",
    cx: 22.302,
    cy: 22.015,
    rx: 22.302,
    ry: 22.015
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 22.501,
    cy: 22.141,
    rx: 19.608,
    ry: 19.357
  })), /*#__PURE__*/React.createElement("path", {
    d: "m208.955 133.61 8.071 4.519 2.878-4.827-6.427-6.421a22.982 22.982 0 0 0-2.599 3.206 23.442 23.442 0 0 0-1.878 3.371",
    fill: "#EACC7D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.143 133.267 6.812-6.153c.79.69 1.87 1.795 2.805 3.385a13.621 13.621 0 0 1 1.53 3.844l-6.812 3.45-4.335-4.526z",
    fill: "#DC4D55",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.03 125.554 7.648 8.045h4.71l8.052-7.942c-.718-.72-4.313-4.171-10.045-4.282-5.682-.11-9.388 3.142-10.147 3.836",
    fill: "#75B967",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 225.052,
    cy: 137.492,
    rx: 11.021,
    ry: 10.592
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#462D41",
    strokeWidth: 0.763,
    fill: "#462D41",
    fillRule: "nonzero",
    strokeLinecap: "round",
    d: "m223.25 140.405 12.502-10.169"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.133 198.029)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 19.157 3.965 65.08a22.437 22.437 0 0 0 3.626 5.85c4.533 5.26 10.334 6.881 15.452 8.239 9.85 2.611 18.157 1.605 21.706 1.014 6.961-1.156 16.826-2.795 22.543-10.863 1.778-2.509 2.683-4.972 3.171-6.725l-4.075-66.903c-.504-1.59-1.473-3.923-3.42-6.146-2.64-3.02-5.919-4.507-10.262-5.776-5.403-1.583-13.02-3.81-23.359-2.563-7.442.896-16.578 1.789-23.626 8.922-2.966 3-4.656 6.17-5.61 8.365",
    fill: "#B6BDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.534 46.022 1.858 30.49a15.348 15.348 0 0 0 3.137 4.145c3.946 3.718 9.04 4.816 13.544 5.735 8.659 1.765 15.994.96 19.135.503 6.148-.9 14.868-2.17 19.99-7.995a14.906 14.906 0 0 0 2.865-4.843l-2.912-47.796a11.478 11.478 0 0 0-2.953-4.362c-2.298-2.132-5.175-3.161-8.991-4.026-4.752-1.076-11.442-2.59-20.574-1.594-6.572.717-14.635 1.449-20.928 6.619-2.649 2.177-4.168 4.457-5.034 6.04M4.629 31.202l1.072 17.554",
    fill: "#D2D6EB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6BDDD",
    d: "m14.16 93.714 10.952-.666.628 10.321-10.951.666zM33.607 94.603l10.952-.665.628 10.321-10.951.665zM51.406 90.618l10.952-.665.628 10.321-10.952.665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 51.63 1.9 31.208a24.48 24.48 0 0 0 3.77 4.804c11.88 11.736 33.053 11.175 43.365 4.45 7.182-4.686 11.193-11.66 11.193-11.66.172-.297.305-.545.397-.713l-1.939-31.84L5.721 51.63h-.004z",
    fill: "#DC4D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.114 32.876 32.878-1.997a3.648 3.648 0 0 1 3.862 3.42l2.136 35.07a3.648 3.648 0 0 1-3.42 3.864L20.692 75.23a3.648 3.648 0 0 1-3.863-3.42l-2.135-35.07a3.648 3.648 0 0 1 3.42-3.864z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.571 39.956c-2.095 2.204-4.201 4.423-5.942 6.916-1.74 2.494-3.117 5.3-3.59 8.305-.191 1.197-.233 2.413-.233 3.626 0 1.07.042 2.158.328 3.19.805 2.929 3.556 5.068 6.533 5.708 2.973.637 6.106-.041 8.873-1.303 2.572-1.175 5.03-2.993 6.075-5.62 1.046-2.639.485-5.697-.858-8.198-1.344-2.501-3.39-4.54-5.438-6.5-2.05-1.964-4.16-3.916-5.683-6.31M17.117 90.59l5.283-.321.596 9.784-5.284.321zM54.246 88.224l5.284-.32.595 9.784-5.283.32zM36.392 92.863l5.283-.32.596 9.784-5.283.32z",
    fill: "#DC4D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.58 6.464 16.263-.988a2.35 2.35 0 0 1 .286 4.693l-16.263.988a2.35 2.35 0 0 1-.286-4.693z",
    fill: "#CDDEE3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CDDEE3",
    cx: 33.148,
    cy: 5.977,
    rx: 3,
    ry: 2.997
  })), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#462D41",
    strokeWidth: 0.763,
    fill: "#462D41",
    fillRule: "nonzero",
    strokeLinecap: "round",
    cx: 225.529,
    cy: 138.62,
    rx: 1.019,
    ry: 1.018
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.464 162.927v36c0 12.693 10.3 22.983 23.004 22.983h23.928",
    stroke: "#462D41",
    strokeWidth: 4.961
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA6463",
    fillRule: "nonzero",
    d: "m266.489 219.276 5.068 5.257.095-5.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1F1F5",
    fillRule: "nonzero",
    d: "m67.81 163.613.042 2.63 5.378-1.215-1.237-2.433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.529 166.85 14.1-3.27a1.436 1.436 0 0 1 1.722 1.073l11.1 47.773-16.898 3.92-11.101-47.774a1.435 1.435 0 0 1 1.073-1.72l.004-.001z",
    fill: "#8DBBC7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FA",
    fillRule: "nonzero",
    d: "m67.663 217.35 29.025-6.51.404 1.798-29.025 6.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FA",
    fillRule: "nonzero",
    d: "m77.54 215.86 9.243-2.192 5.52 23.242-9.242 2.191z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FA",
    fillRule: "nonzero",
    d: "m78.69 239.677 17.706-3.97.272 1.209-17.706 3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.547 152.22 1.294 11.248c.03.275.298.462.569.397l5.117-1.228a.46.46 0 0 0 .32-.621l-4.254-10.638a.463.463 0 0 0-.557-.275l-2.153.614a.458.458 0 0 0-.332.496l-.004.008z",
    fill: "#37525E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37525E",
    fillRule: "nonzero",
    d: "m59.639 120.586.439-.101 7.932 34.354-.439.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D34973",
    fillRule: "nonzero",
    d: "m63.892 168.763 14.03-3.37 6.236 25.913-14.03 3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B8285",
    fillRule: "nonzero",
    d: "m69.99 194.38 14.03-3.37 1.652 6.866-14.029 3.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "m63.308 172.229 7.456-1.733.053.226-7.456 1.734zM63.693 173.862l5.084-1.182.053.226-5.085 1.182zM64.061 175.446l5.085-1.182.053.226-5.085 1.182zM64.449 177.114l5.085-1.182.052.226-5.084 1.182zM64.817 178.697l5.085-1.182.053.226-5.085 1.183zM65.213 180.39l7.456-1.734.053.226-7.456 1.734zM65.593 182.023l5.085-1.182.053.226-5.085 1.182zM65.958 183.603l5.085-1.182.053.226-5.085 1.183zM66.35 185.275l5.085-1.182.052.226-5.085 1.182zM66.719 186.862l5.085-1.183.053.227-5.085 1.182zM67.152 188.724l7.457-1.734.052.227-7.456 1.733zM67.533 190.357l5.085-1.182.053.227-5.085 1.182zM67.901 191.94l5.085-1.182.053.227-5.085 1.182zM68.293 193.609l5.085-1.183.053.227-5.085 1.182zM68.642 195.203l5.084-1.182.053.227-5.085 1.182zM69.087 197.052l7.457-1.734.052.227-7.456 1.733zM69.469 198.778l5.084-1.183.053.227-5.085 1.182zM69.84 200.357l5.086-1.182.052.226-5.084 1.182zM70.229 202.029l5.085-1.183.052.227-5.085 1.182zM70.597 203.609l5.085-1.182.053.226-5.085 1.182zM71.03 205.474l7.457-1.734.052.227-7.456 1.733z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtMedicalSupplies);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-medical-supplies.2aca4049e08e030756c7e01d1d5d7e90.svg";